<template>
<div id="kanban-board">
    <div class="container-fluid mb-3">
            <div class="container text-center mb-3">
                <h1 class="font-monospace">Kanban Board</h1>
                <div class="btn btn-outline-success">
                    <i id="addTask"
                    @click.prevent="changePage('AddTask')" 
                    @addData="addData"
                    class="fas fa-plus-circle btn-outline-success">Add Task</i>
                </div>
            </div>
            <div class="row">
                <Category :title="'Backlog'" 
                @addData="addData"
                @deleteData="deleteData"
                @fetchDetail="fetchDetail"
                :listTask="TaskBacklog"></Category>
                <Category :title="'Doing'"
                @addData="addData"
                @deleteData="deleteData"
                @fetchDetail="fetchDetail" 
                :listTask="TaskDoing"></Category>
                <Category :title="'Todo'" 
                @addData="addData"
                @deleteData="deleteData"
                @fetchDetail="fetchDetail"
                :listTask="TaskTodo"></Category>
                <Category :title="'Done'" 
                @addData="addData"
                @deleteData="deleteData"
                @fetchDetail="fetchDetail"
                :listTask="TaskDone"></Category>
            </div>
    </div>
            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Task</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
          <!-- {{detailTask}} -->
        <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input type="text" 
            name="title" 
            id="title" 
            class="form-control" 
            v-model="detailTask.title">
        </div>
        <div class="mb-3">
            <label for="category" class="form-label">Category</label>
            <input type="text" 
            name="category" 
            id="category" 
            class="form-control" 
            v-model="detailTask.category">

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click.prevent="editTask(detailTask.id)">Save changes</button>
      </div>
    </div>
  </div>
            </div>
</div>
</template>

<script>
import AddTask from "./AddTask"
import Category from "../components/Category"
export default {
    name: "Dashboard",
    components: {
        AddTask,
        Category
    },
    data() {
        return {
            category: ['Backlog', 'Todo', 'Doing', 'Done']
        }
    },
    props: ["detailTask", "listTask"],
    methods: {
        changePage(data) {
            this.$emit('changePage', data)
        },
        addData(data) {
            console.log(data, '<< dta');
            this.$emit('addTask', data)
        },
        deleteData(id) {
            this.$emit('deleteData', id)
        },
        fetchDetail(id, data) {
            this.$emit('fetchDetail', id)  
        },
        editTask(id) {
            console.log(id, '<< dashboard');
            this.$emit('editTask', id)
        }
    },
    computed: {
        TaskBacklog() {
            if (this.listTask.task) {
                return this.listTask.task.filter((task) => task.category === "Backlog");
            } else {
                return []
            }
        },
        TaskDoing() {
            if (this.listTask.task) {
                return this.listTask.task.filter((task) => task.category === "Doing");
            } else {
                return []
            }
        },
        TaskTodo() {
            if (this.listTask.task) {
                return this.listTask.task.filter((task) => task.category === "Todo");
            } else {
                 return []
            }
        },
        TaskDone() {
            if (this.listTask.task) {
                return this.listTask.task.filter((task) => task.category === "Done");
            } else {
                return []
            }
        } 
    }
}
</script>

<style>

</style>